import React, { Component } from 'react'
import { connect } from 'react-redux'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import * as actions from '../actions'
import { GeneralStyledContent } from '../../../../styled/common-styled'
import Breadcrumb from './../../../shared/components/Breadcrumb'
import { helper_convertDateformat } from '../../../../lib/helper'
import { checkPermissions } from '../../../../lib/helper'
import { getlocalstorage } from './../../../../constants/local_storage'
import AuthorizeComponent from '../../../auth/components/AuthorizeComponent'
import {
  Button,
  Table,
  Row,
  Col,
  Popconfirm,
  Icon,
  Tooltip,
  Drawer,
  message,
  Modal,
} from 'antd'
import moment from 'moment'
import axios from 'axios'
import { Link } from 'react-router-dom'
import Filter from './Filter'
import RemarkModal from './RemarkModal'
const columnStyle = { fontSize: '12px', fontWeight: '400' }
const { confirm } = Modal
class Index extends Component {
  state = {
    visible: false,
    page: 1,
    pageSize: 10,
    orderBy: 'm.id',
    orderType: 'desc',
    visibleModalRemark: false,
    selectedRowKeys: [], // Check here to configure the default column
    EditRemarkID: '',
    EditRemarkValue: '',
    filterObj: {
      plate_no: '',
      doc_number: '',
      maintenance_status_id: '',
      inform_date: '',
      date_start: '',
      date_end: '',
      type_problem_id: '',
    },
  }

  showDrawer = () => {
    this.setState({
      visible: true,
    })
  }

  onCloseSearch = resetForm => {
    this.setState({
      visible: false,
    })
  }

  filterMaintenancedevice = values => {
    const {
      plate_no,
      doc_number,
      maintenance_status_id,
      inform_date,
      type_problem_id,
    } = values
    const date_start =
      inform_date == '' ? '' : moment(inform_date[0]['_d']).format('YYYY-MM-DD')
    const date_end =
      inform_date == '' ? '' : moment(inform_date[1]['_d']).format('YYYY-MM-DD')
    this.setState({
      page: 1,
      filterObj: {
        plate_no,
        date_start,
        date_end,
        doc_number,
        maintenance_status_id,
        type_problem_id,
        inform_date: '',
      },
      // filterObj: {
      //     plate_no: '',
      //     doc_number: '',
      //     maintenance_status_id: '',
      //     inform_date: '',
      //     date_start: '',
      //     date_end: '',
      //     type_problem_id: '',
      // },
    })
    this.props.loadMaintenancedevice(
      {
        page: 1,
        pageSize: this.state.pageSize,
        orderBy: this.state.orderBy,
        orderType: this.state.orderType,
        filterObj: this.state.filterObj,
        // filterObj: {
        //     plate_no,
        //     date_start,
        //     date_end,
        //     doc_number,
        //     maintenance_status_id,
        //     type_problem_id,
        // },
      },
      true,
    )
  }

  loadPageData = () => {
    this.props.loadMaintenancedevice(this.state, true)
    this.props.loadMaintenancestatus()
    this.props.loadTypeproblem()
  }

  componentDidMount() {
    this.loadPageData()
  }

  componentDidUpdate(prevProps, prevState) {
    const { dataResponse } = this.props.maintenancedevice

    if (
      dataResponse.action_type == 'create' ||
      dataResponse.action_type == 'update'
    ) {
      if (dataResponse.status == 'success') {
        message.info('สำเร็จ')
      } else if (dataResponse.status == 'fail') {
        message.info(dataResponse.msg)
      }
      this.props.clearDataResponse()
    }
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      page: pagination.current,
    })

    let orderBy = ''
    let orderType = ''

    if (Object.keys(sorter).length === 0 && sorter.constructor === Object) {
      this.setState({
        orderBy: 'm.id',
        orderType: 'desc',
      })
      orderBy = 'm.id'
      orderType = 'desc'
    } else {
      this.setState({
        orderBy: sorter.columnKey,
        orderType: sorter.order == 'descend' ? 'desc' : 'asc',
      })
      orderBy = sorter.columnKey
      orderType = sorter.order == 'descend' ? 'desc' : 'asc'
    }

    this.props.loadMaintenancedevice(
      {
        page: pagination.current,
        pageSize: this.state.pageSize,
        searchName: '',
        orderBy: orderBy,
        orderType: orderType,
        filterObj: this.state.filterObj,
        // filterObj: {
        //     plate_no: this.state.filterObj.plate_no,
        //     date_start: this.state.filterObj.date_start,
        //     date_end: this.state.filterObj.date_end,
        //     doc_number: this.state.filterObj.doc_number,
        //     maintenance_status_id: this.state.filterObj.maintenance_status_id,
        // },
      },
      true,
    )
  }

  deleteMaintenancedevice = id => {
    let self = this

    axios
      .get(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/maintenancedevice/delete/${id}`,
        {
          headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
        },
      )
      .then(function(response) {
        self.props.loadMaintenancedevice(
          {
            page: 1,
            pageSize: self.state.pageSize,
            orderBy: self.state.orderBy,
            orderType: self.state.orderType,
            filterObj: {
              plate_no: self.state.filterObj.plate_no,
              date_start: self.state.filterObj.date_start,
              date_end: self.state.filterObj.date_end,
              doc_number: self.state.filterObj.doc_number,
              maintenance_status_id: self.state.filterObj.maintenance_status_id,
              type_problem_id: self.state.filterObj.type_problem_id,
            },
          },
          true,
        )
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  checkVehicleInTerminus = (record, vehicle_code, i18n) => {
    let self = this
    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/maintenancedevice/checkvehicleinterminus`,
        {
          vehicle_code,
        },
        {
          headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
        },
      )
      .then(function(response) {
        if (response.data.vehicle_id == null) {
          self.haveCarInTerminus(record, i18n, response.data.vehicle_id)
        } else {
          self.changeStatusMaintenancedevice(
            record.id,
            2,
            record.type_problem_id,
            record.gps_vendor_id,
            true,
          )
        }
      })
  }

  haveCarInTerminus = (record, i18n, vehicle_id) => {
    let self = this
    confirm({
      title: i18n.f.failedToOpenTicketAtTerminus,
      content: i18n.t.theVehicleWasNotFoundInTheTERMINUSSystem,
      okText: i18n.o.openATicketAtTheCpacSystem,
      cancelText: i18n.c.cancel,
      onOk() {
        self.changeStatusMaintenancedevice(
          record.id,
          2,
          record.type_problem_id,
          record.gps_vendor_id,
          false,
        )
      },
      onCancel() {},
    })
  }

  changeStatusMaintenancedevice = (
    id,
    maintenance_status_id,
    type_problem_id,
    gps_vendor_id,
    have_car_in_terminus,
  ) => {
    let self = this
    const user_id = getlocalstorage(localStorage.getItem('profile'), 'id')

    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/maintenancedevice/updatestatus`,
        {
          maintenance_status_id,
          type_problem_id,
          user_id,
          id,
          gps_vendor_id,
          have_car_in_terminus,
        },
        {
          headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
        },
      )
      .then(function(response) {
        self.props.loadMaintenancedevice(
          {
            page: self.state.page,
            pageSize: self.state.pageSize,
            orderBy: self.state.orderBy,
            orderType: self.state.orderType,
            filterObj: {
              plate_no: self.state.filterObj.plate_no,
              date_start: self.state.filterObj.date_start,
              date_end: self.state.filterObj.date_end,
              doc_number: self.state.filterObj.doc_number,
              maintenance_status_id: self.state.filterObj.maintenance_status_id,
              type_problem_id: self.state.filterObj.type_problem_id,
            },
          },
          true,
        )
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  handleDisplayRemarkModal = (value, id, remark) => () => {
    this.setState({
      visibleModalRemark: value,
      EditRemarkID: id,
      EditRemarkValue: remark,
    })
  }

  onSelectChange = selectedRowKeys => {
    //console.log('selectedRowKeys changed: ', selectedRowKeys)
    this.setState({ selectedRowKeys })
  }

  showConfirm = i18n => {
    if (this.state.selectedRowKeys.length > 0) {
      const user_id = getlocalstorage(localStorage.getItem('profile'), 'id')
      let self = this
      confirm({
        // title: i18n.c.confirmToChangeStatus,
        content: i18n.c.confirmToChangeStatus,
        okText: i18n.o.ok,
        cancelText: i18n.c.cancel,
        onOk() {
          axios
            .post(
              `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/maintenancedevice/updatestatusmulti`,
              {
                user_id,
                id: self.state.selectedRowKeys,
              },
              {
                headers: {
                  Authorization: `Bearer ${self.props.auth.accessToken}`,
                },
              },
            )
            .then(function(response) {
              self.setState({ selectedRowKeys: [] })
              self.props.loadMaintenancedevice(
                {
                  page: self.state.page,
                  pageSize: self.state.pageSize,
                  orderBy: self.state.orderBy,
                  orderType: self.state.orderType,
                  filterObj: {
                    plate_no: self.state.filterObj.plate_no,
                    date_start: self.state.filterObj.date_start,
                    date_end: self.state.filterObj.date_end,
                    doc_number: self.state.filterObj.doc_number,
                    maintenance_status_id:
                      self.state.filterObj.maintenance_status_id,
                    type_problem_id: self.state.filterObj.type_problem_id,
                  },
                },
                true,
              )
            })
            .catch(function(error) {
              console.log(error)
            })
        },
        onCancel() {},
      })
    } else {
      message.error(i18n.p.pleaseSelectWorksheetMaintenance)
    }
  }

  render() {
    const { selectedRowKeys } = this.state
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      hideDefaultSelections: true,
    }
    const columns = [
      {
        title: <div className="regular-bold-14">#</div>,
        className: 'column-text-center',
        dataIndex: 'row_number',
        width: '1%',
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>{i18n => i18n.d.doc_no}</LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'document_number',
        sorter: true,
        key: 'document_number',
        width: '7%',
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.p.plateNo}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'plate_no',
        sorter: true,
        key: 'plate_no',
        width: '9%',
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.c.connection}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'gps_active_at',
        key: 'gps_active_at',
        render(text, record, index) {
          let gps_active_at = text
          if (text != '-' && text != '') {
            gps_active_at =
              moment
                .utc()
                .local()
                .diff(
                  moment(text, 'YYYY-MM-DD HH:mm:ss')
                    .utc()
                    .local(),
                  'minutes',
                ) <= 30
                ? 'now'
                : moment(text)
                    //   .add(7, "hours")
                    .format('YYYY-MM-DD HH:mm:ss')
          }
          return {
            props: {
              style: columnStyle,
            },
            children:
              gps_active_at == 'now' ? (
                <div style={{ fontSize: '9px' }}>
                  <LangContext.Consumer>
                    {i18n => i18n.n.now}
                  </LangContext.Consumer>
                </div>
              ) : (
                <div style={{ fontSize: '9px', color: 'red' }}>
                  {helper_convertDateformat(
                    gps_active_at,
                    'YYYY-MM-DD HH:mm',
                    'DD/MM/YY HH:mm',
                  )}
                </div>
              ),
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.p.primary_location}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'primary_location',
        sorter: true,
        key: 'primary_location',
        width: '7%',
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.s.submit_name}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'submit_name',
        sorter: true,
        key: 'submit_name',
        width: '8%',
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.c.contact_name}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'contact_name',
        sorter: true,
        key: 'contact_name',
        width: '8%',
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.d.detail_problem}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'type_problem',
        sorter: false,
        width: '10%',
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.c.comment}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'comment',
        sorter: false,
        width: '9%',
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.i.inform_date}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'inform_date',
        sorter: true,
        key: 'inform_date',
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div>
                {helper_convertDateformat(
                  text,
                  'YYYY-MM-DD HH:mm',
                  'DD/MM/YYYY HH:mm',
                )}
              </div>
            ),
          }
        },
        width: '8%',
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.r.receive_date}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'receive_date',
        sorter: true,
        key: 'receive_date',
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div>
                {helper_convertDateformat(
                  text,
                  'YYYY-MM-DD HH:mm',
                  'DD/MM/YYYY HH:mm',
                )}
              </div>
            ),
          }
        },
        width: '7%',
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.c.complete_date}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'finish_date',
        key: 'finish_date',
        sorter: true,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div>
                {helper_convertDateformat(
                  text,
                  'YYYY-MM-DD HH:mm',
                  'DD/MM/YYYY HH:mm',
                )}
              </div>
            ),
          }
        },
        width: '8%',
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.r.remarkVendor}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'vendor_remark',
        key: 'vendor_remark',
        width: '7%',
        render: (text, record, index) => {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div>
                <Button
                  type="link"
                  icon="edit"
                  onClick={this.handleDisplayRemarkModal(
                    true,
                    record.id,
                    record.vendor_remark,
                  )}
                />
                {record.vendor_remark}
              </div>
            ),
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.m.maintenance_status}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'maintenance_status',
        sorter: false,
        width: '5%',
        render(text, record, index) {
          let color_message = ''
          if (record.maintenances_status_id == 1) {
            color_message = 'red'
          } else if (record.maintenances_status_id == 2) {
            color_message = 'orange'
          } else if (record.maintenances_status_id == 3) {
            color_message = 'green'
          }
          return {
            props: {
              style: columnStyle,
            },
            children: <div style={{ color: color_message }}>{text}</div>,
          }
        },
      },

      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>{i18n => i18n.a.action}</LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'action',
        key: 'action',
        sorter: false,
        width: '9%',
        render: (text, record, index) => {
          var btAction = ''
          if (record.maintenances_status_id == 1) {
            btAction = (
              <LangContext.Consumer>
                {i18n => (
                  <Tooltip
                    placement="left"
                    title={i18n.r.receive}
                    arrowPointAtCenter
                  >
                    <Popconfirm
                      title={i18n.c.confirmToReceiveStatus}
                      onConfirm={() => {
                        let self = this
                        if (record.gps_vendor_id == 1) {
                          self.checkVehicleInTerminus(record, record.code, i18n)
                        } else {
                          self.changeStatusMaintenancedevice(
                            record.id,
                            2,
                            record.type_problem_id,
                            record.gps_vendor_id,
                            false,
                          )
                        }
                      }}
                      cancelText={i18n.c.cancel}
                      okText={i18n.o.ok}
                    >
                      <a
                        href="javascript:;"
                        style={{ padding: '0px 15px 0px 5px' }}
                      >
                        {i18n.r.receive}
                      </a>
                    </Popconfirm>
                  </Tooltip>
                )}
              </LangContext.Consumer>
            )
          }
          if (record.maintenances_status_id == 2) {
            btAction = (
              <LangContext.Consumer>
                {i18n => (
                  <Tooltip
                    placement="left"
                    title={i18n.c.complete}
                    arrowPointAtCenter
                  >
                    <Popconfirm
                      title={i18n.c.confirmToCloseStatus}
                      onConfirm={() => {
                        let self = this
                        self.changeStatusMaintenancedevice(
                          record.id,
                          3,
                          record.type_problem_id,
                          record.gps_vendor_id,
                          false,
                        )
                      }}
                      cancelText={i18n.c.cancel}
                      okText={i18n.o.ok}
                    >
                      <a
                        href="javascript:;"
                        style={{ padding: '0px 15px 0px 5px' }}
                      >
                        {i18n.c.complete}
                      </a>
                    </Popconfirm>
                  </Tooltip>
                )}
              </LangContext.Consumer>
            )
          }
          return (
            <div>
              {checkPermissions(
                this.props.auth.profile.permissions,
                'maintenancedevice',
                'can_delete',
              ) === true && this.props.auth.profile.is_gps_vendor !== 1 ? (
                <LangContext.Consumer>
                  {i18n => (
                    <Tooltip
                      placement="left"
                      title={i18n.d.delete}
                      arrowPointAtCenter
                    >
                      <Popconfirm
                        title={i18n.c.confirmToDeleteThisItem}
                        onConfirm={() => {
                          let self = this
                          self.deleteMaintenancedevice(record.id)
                        }}
                        cancelText={i18n.c.cancel}
                        okText={i18n.o.ok}
                      >
                        <a
                          href="javascript:;"
                          style={{ padding: '0px 15px 0px 5px' }}
                        >
                          <Icon type="close" />
                        </a>
                      </Popconfirm>
                    </Tooltip>
                  )}
                </LangContext.Consumer>
              ) : (
                ''
              )}

              {checkPermissions(
                this.props.auth.profile.permissions,
                'maintenancedevice',
                'can_edit',
              ) === true && this.props.auth.profile.is_gps_vendor !== 1 ? (
                <Tooltip placement="left" title="แก้ไข" arrowPointAtCenter>
                  <Link to={`/maintenancedevice/edit/${record.id}`}>
                    <Icon type="edit" />
                  </Link>
                </Tooltip>
              ) : (
                ''
              )}

              {this.props.auth.profile.is_gps_vendor === 1 ? btAction : ''}
            </div>
          )
        },
        // width: "5%"
      },
    ]

    return (
      <div>
        <AuthorizeComponent {...this.props} matching_name="maintenancedevice">
          <RemarkModal
            visible={this.state.visibleModalRemark}
            handleCancel={this.handleDisplayRemarkModal(false, '', '')}
            Id={this.state.EditRemarkID}
            value={this.state.EditRemarkValue}
            reLoad={this.loadPageData}
            accessToken={this.props.auth.accessToken}
          />
          <GeneralStyledContent>
            <Row gutter={24}>
              <Col span={24}>
                {/* <Breadcrumb
                  match={this.props.match}
                  style={{ margin: '0px 0px 14px 10px' }}
                /> */}
                <div className="header__text">
                  <LangContext.Consumer>
                    {i18n => i18n.m.maintenancedevice}
                  </LangContext.Consumer>
                </div>
              </Col>
            </Row>
            <Row
              gutter={24}
              type="flex"
              justify="end"
              style={{ height: '38px' }}
            >
              <Col span={22}>
                {checkPermissions(
                  this.props.auth.profile.permissions,
                  'maintenancedevice',
                  'can_add',
                ) === true && this.props.auth.profile.is_gps_vendor !== 1 ? (
                  <Link to="/maintenancedevice/create/">
                    <Button type="primary" icon="plus" size="small">
                      <span></span>
                      <LangContext.Consumer>
                        {i18n => i18n.n.new}
                      </LangContext.Consumer>
                    </Button>
                  </Link>
                ) : (
                  <LangContext.Consumer>
                    {i18n => (
                      <Button
                        size="small"
                        onClick={() => this.showConfirm(i18n)}
                      >
                        <LangContext.Consumer>
                          {i18n => i18n.r.receive_complete}
                        </LangContext.Consumer>
                      </Button>
                    )}
                  </LangContext.Consumer>
                )}
              </Col>

              <Col span={2}>
                <Button icon="filter" size="small" onClick={this.showDrawer}>
                  <LangContext.Consumer>
                    {i18n => i18n.f.filter}
                  </LangContext.Consumer>
                </Button>
              </Col>
            </Row>
            <Table
              bordered
              size="small"
              rowSelection={
                this.props.auth.profile.is_gps_vendor === 1 ? rowSelection : ''
              }
              columns={columns}
              rowKey={record => record.id}
              dataSource={this.props.maintenancedevice.maintenancedeviceLists}
              pagination={{
                pageSize: this.state.pageSize,
                total: this.props.maintenancedevice.maintenancedeviceTotal,
                current: this.state.page,
              }}
              loading={this.props.maintenancedevice.maintenancedeviceLoading}
              onChange={this.handleTableChange}
            />

            <div>
              <LangContext.Consumer>
                {i18n => (
                  <Drawer
                    title={i18n.s.search}
                    width={350}
                    onClose={this.onCloseSearch}
                    visible={this.state.visible}
                  >
                    <Filter
                      OnClose={this.onCloseSearch}
                      onSubmit={this.filterMaintenancedevice}
                      maintenancestatusLists={
                        this.props.maintenancedevice.maintenancestatusLists
                      }
                      typeproblemLists={
                        this.props.maintenancedevice.typeproblemLists
                      }
                    />
                  </Drawer>
                )}
              </LangContext.Consumer>
            </div>
          </GeneralStyledContent>
        </AuthorizeComponent>
      </div>
    )
  }
}

const mapStateToProps = ({ maintenancedevice, auth }) => ({
  maintenancedevice,
  auth,
})

const mapDispatchToProps = {
  loadMaintenancedevice: actions.loadMaintenancedevice.request,
  loadTypeproblem: actions.loadTypeproblem.request,
  loadMaintenancestatus: actions.loadMaintenancestatus.request,
  clearDataResponse: actions.clearDataResponse,
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
